var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 14.25V9.75C6.75 8.92157 6.07843 8.25 5.25 8.25H3.75C2.92157 8.25 2.25 8.92157 2.25 9.75V14.25C2.25 15.0784 2.92157 15.75 3.75 15.75H5.25C6.07843 15.75 6.75 15.0784 6.75 14.25ZM6.75 14.25V6.75C6.75 5.92157 7.42157 5.25 8.25 5.25H9.75C10.5784 5.25 11.25 5.92157 11.25 6.75V14.25M6.75 14.25C6.75 15.0784 7.42157 15.75 8.25 15.75H9.75C10.5784 15.75 11.25 15.0784 11.25 14.25M11.25 14.25V3.75C11.25 2.92157 11.9216 2.25 12.75 2.25H14.25C15.0784 2.25 15.75 2.92157 15.75 3.75V14.25C15.75 15.0784 15.0784 15.75 14.25 15.75H12.75C11.9216 15.75 11.25 15.0784 11.25 14.25Z",
    stroke: "#212121",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBar);
export default __webpack_public_path__ + "static/media/chart-bar.6907b16a2dc60e3c21a60f5a26a1b9b1.svg";
export { ForwardRef as ReactComponent };